module.exports = __webpack_public_path__ + "static/media/1009781.df452413.jpg";